// extracted by mini-css-extract-plugin
export var counter = "Counter-module--counter--c016a";